import type { ListType } from "@/interface/common";

interface ExtendListType {
  class: string;
  activeClass: string;
}
export const themeList: ListType<ExtendListType> = [
  {
    label: "绿",
    value: "green",
    class: "green-class",
    activeClass: "green-class-active",
  },
  {
    label: "白",
    value: "white",
    class: "white-class",
    activeClass: "white-class-active",
  },
  {
    label: "棕",
    value: "brown",
    class: "brown-class",
    activeClass: "brown-class-active",
  },
  {
    label: "蓝",
    value: "blue",
    class: "blue-class",
    activeClass: "blue-class-active",
  },
  {
    label: "黑",
    value: "dark",
    class: "dark-class",
    activeClass: "dark-class-active",
  },
];
